import { useEffect, useState } from "react";
import api, { money, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Users, Phone, Mail, Ban, CheckCircle2, ShieldAlert } from "lucide-react";

export default function Clients() {
  const [clients, setClients] = useState([]);

  const load = () => api.get("/clients").then((r) => setClients(r.data || []));
  useEffect(() => { load(); }, []);

  const toggleBlock = async (c) => {
    try {
      await api.put(`/clients/${c.id}/block`, { blocked: !c.blocked });
      toast.success(!c.blocked ? "Cliente bloqueado para novos agendamentos" : "Cliente desbloqueado");
      load();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail) || "Erro"); }
  };

  return (
    <div>
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-1">Clientes</h1>
      <p className="text-zinc-400 mb-6">{clients.length} cliente(s) cadastrado(s).</p>

      {clients.length === 0 ? (
        <div className="text-center py-16 bg-zinc-900 border border-zinc-800 rounded-2xl text-zinc-500"><Users className="w-10 h-10 mx-auto mb-3 text-zinc-600" />Nenhum cliente cadastrado ainda.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {clients.map((c) => (
            <div key={c.id} className={`bg-zinc-900 border rounded-2xl p-5 ${c.blocked ? "border-red-500/40" : "border-zinc-800"}`} data-testid={`client-${c.id}`}>
              <div className="flex items-center gap-3">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${c.blocked ? "bg-red-500/15 text-red-400" : "bg-amber-500/15 text-amber-400"}`}>{c.name?.[0]?.toUpperCase()}</div>
                <div className="min-w-0">
                  <div className="text-white font-semibold truncate">{c.name}</div>
                  {c.blocked && <span className="inline-flex items-center gap-1 text-xs text-red-400 mt-0.5" data-testid={`client-blocked-badge-${c.id}`}><ShieldAlert className="w-3 h-3" /> Bloqueado</span>}
                </div>
              </div>
              <div className="mt-4 space-y-1.5 text-sm text-zinc-400">
                {c.phone && <p className="flex items-center gap-2"><Phone className="w-4 h-4 text-amber-400" /> {c.phone}</p>}
                {c.email && <p className="flex items-center gap-2 truncate"><Mail className="w-4 h-4 text-amber-400" /> {c.email}</p>}
              </div>
              <div className="mt-4 pt-4 border-t border-zinc-800 flex justify-between text-sm">
                <span className="text-zinc-400">Agendamentos: <span className="text-white font-semibold">{c.total_appointments}</span></span>
                <span className="text-amber-400 font-semibold">{money(c.total_spent)}</span>
              </div>
              <Button
                size="sm"
                variant="outline"
                className={`w-full mt-4 ${c.blocked ? "border-green-500/40 text-green-400 hover:bg-green-500/10" : "border-red-500/40 text-red-400 hover:bg-red-500/10"}`}
                onClick={() => toggleBlock(c)}
                data-testid={`client-block-btn-${c.id}`}
              >
                {c.blocked ? <><CheckCircle2 className="w-4 h-4 mr-1" /> Desbloquear</> : <><Ban className="w-4 h-4 mr-1" /> Bloquear agendamentos</>}
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
